function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M439.195 225.31L503 256.5 256.5 377 10 256.5l63.805-31.19L256.5 314.618z"
}), React.createElement("path", {
  d: "M439.195 323L503 354.19l-246.5 120.5L10 354.19 73.805 323 256.5 412.31zM256.5 38L503 158.5 256.5 279 10 158.5z"
}));

const SvgComponent = props => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), _ref);

export default __webpack_public_path__ + "static/media/layers.261da336.svg";
export { SvgComponent as ReactComponent };